/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InsertClickoutInput = {|
  listingId: string,
  countryCode?: ?string,
  source?: ?string,
  clientMutationId?: ?string,
|};
export type AggregatesListingCardClickoutInsertMutationVariables = {|
  input: InsertClickoutInput
|};
export type AggregatesListingCardClickoutInsertMutationResponse = {|
  +insertClickout: ?{|
    +clientMutationId: ?string
  |}
|};
export type AggregatesListingCardClickoutInsertMutation = {|
  variables: AggregatesListingCardClickoutInsertMutationVariables,
  response: AggregatesListingCardClickoutInsertMutationResponse,
|};
*/


/*
mutation AggregatesListingCardClickoutInsertMutation(
  $input: InsertClickoutInput!
) {
  insertClickout(input: $input) {
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InsertClickoutPayload",
    "kind": "LinkedField",
    "name": "insertClickout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AggregatesListingCardClickoutInsertMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AggregatesListingCardClickoutInsertMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "68f1bd2d42e47c8a72ffa9185a60f409",
    "id": null,
    "metadata": {},
    "name": "AggregatesListingCardClickoutInsertMutation",
    "operationKind": "mutation",
    "text": "mutation AggregatesListingCardClickoutInsertMutation(\n  $input: InsertClickoutInput!\n) {\n  insertClickout(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9e6ea431fc3cc74a7400ee46778da877';

export default node;
